import { StyledCreateTownhallModal } from "./styledComponents";
import { CreateTownhallModalContent, CreateTownhallModalProps } from "./CreateTownhallModalContent";
import { ButtonAnalyticsProvider } from "@kaltura/mediaspace-shared-hooks";

/**
 * Create Townhall Modal component
 */
export const CreateTownhallModal = (props: CreateTownhallModalProps) => {
    const { mode = "kwebcast", ...formProps } = props;

    let analyticsLocation: string;
    switch (mode) {
        case "kwebcast":
            analyticsLocation = "Create Townhall Modal box";
            break;
        case "live-studio":
            analyticsLocation = "Create Live studio Modal box";
            break;
        case "simulive":
            analyticsLocation = "Create Simulive Modal box";
            break;
    }

    return (
        <StyledCreateTownhallModal open={formProps.open} classes={{ paper: "kms-ds-create-townhall-modal" }}>
            <ButtonAnalyticsProvider location={analyticsLocation} applicationFeature={"kwebcast"}>
                <CreateTownhallModalContent mode={mode} {...formProps} />
            </ButtonAnalyticsProvider>
        </StyledCreateTownhallModal>
    );
};
